import { InMemoryCache } from '@apollo/client'

import possibleTypesResult from '@graphql/possible-types'

export const buildCache = () =>
  new InMemoryCache({
    possibleTypes: possibleTypesResult.possibleTypes,
    typePolicies: {
      Query: {
        fields: {
          balance: {
            merge(existing, incoming) {
              return incoming
            },
          },
          user: {
            merge(existing, incoming) {
              return incoming
            },
          },
        },
      },
      Deal: {
        // Unnormalized so cached offer lists keep their order.
        keyFields: false,
      },
      Survey: {
        // Provider surveys share a persisted offer id, so their served fields must stay per-list item.
        keyFields: false,
      },
    },
  })
